export default __webpack_public_path__ + "static/media/OsloFoto_Mobile.7d78fee4.svg";